import React from 'react';
import PropTypes from 'prop-types';
import CheckBox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

const BooleanFacet = ({ name, selected, count, onChange }) => {

  if (!count) {
    return null;
  }

  return (
    <Stack
      spacing={2}
      direction={'row'}
      sx={{
        justifyContent:'space-between',
        alignItems:'center'
      }}
    >
      <Stack
        sx={{
          alignItems:'center'
        }}
        spacing={1} direction={'row'}>
        <CheckBox
          sx={{ pt:0.2, pb:0.2 }}
          checked={selected===true}
          onChange={() => onChange(!selected)}
        />
        <Link underline="hover" variant="inherit" component="button" onClick={() => onChange(!!selected)}>
          <Typography
            sx={{ fontSize:'12px' }}
          >
            {name}
          </Typography>
        </Link>
      </Stack>
      <Typography
        sx={{
          fontWeight: '400',
          fontSize: '12px',
          color: '#252A31',
          lineHeight: '20px'
        }}
      >{count}</Typography>
    </Stack>
  );
};
export { BooleanFacet };
export default BooleanFacet;

BooleanFacet.propTypes={
  name:PropTypes.node.isRequired,
  selected:PropTypes.bool,
  count:PropTypes.number,
  onChange:PropTypes.func,
};
BooleanFacet.defaultProps={
  selected:false,
  count:0,
  onChange:()=>{}
};
